import React from 'react';
import { DataResult } from '../../model/DataResult';
import DollarFormat from '../../format/DollarFormat';
import RatioFormat from '../../format/RatioFormat';
import TextFormat from '../../format/TextFormat';

/**
 * Every year data cell is marked with this class so the CSS for TOTAL and
 * GRAND_TOTAL rows can draw the row's top border reliably on year cells
 * only, regardless of which non-year columns are toggled on/off. The class
 * is intentionally a plain (non CSS-module) global name so it is stable
 * across every format component that renders a year value.
 */
export const YEAR_CELL_CLASS = 'year_cell';

/**
 * Renders a year value as "NA" if the showAsNA flag is set, otherwise renders using DollarFormat
 */
export function renderYearValueAsDollar(yearData: DataResult) {
  if (yearData?.showAsNA) {
    return <p className={`column_align_right ${YEAR_CELL_CLASS}`}>NA</p>;
  }
  return <DollarFormat {...yearData} className={YEAR_CELL_CLASS} />;
}

/**
 * Renders a year value as "NA" if the showAsNA flag is set, otherwise renders using RatioFormat
 */
export function renderYearValueAsRatio(yearData: DataResult) {
  if (yearData?.showAsNA) {
    return <p className={`column_align_right ${YEAR_CELL_CLASS}`}>NA</p>;
  }
  return <RatioFormat {...yearData} className={YEAR_CELL_CLASS} />;
}

/**
 * Renders a year value as "NA" if the showAsNA flag is set, otherwise renders using TextFormat
 */
export function renderYearValueAsText(yearData: DataResult) {
  if (yearData?.showAsNA) {
    return <p className={`align-center ${YEAR_CELL_CLASS}`}>NA</p>;
  }
  return <TextFormat {...yearData} className={YEAR_CELL_CLASS} />;
}

/**
 * Renders a year value as "NA" if the showAsNA flag is set, otherwise renders using the provided format component
 * This is useful for IRIS rows that can display either ratio or text.
 * Callers are responsible for attaching {@link YEAR_CELL_CLASS} to the
 * format element they pass in.
 */
export function renderYearValueWithCustomFormat(
  yearData: DataResult,
  formatComponent: React.ReactElement
) {
  if (yearData?.showAsNA) {
    return <p className={`column_align_right ${YEAR_CELL_CLASS}`}>NA</p>;
  }
  return formatComponent;
}
